import abcImage from './images/ABC.png';
import antena3Image from './images/antena3.png';
import businessInsiderImage from './images/businessInsider.png';
import cadenaserImage from './images/cadenaser.png';
import conDeNastTravelerImage from './images/condenasttraveler.png';
import elPaisImage from './images/elpais.png';
import elPeriodicoImage from './images/elperiodico.png';
import elEconomistaImage from './images/eleconomista.jpg';
import la1Image from './images/la1.png';
import laRazonImage from './images/larazon.png';
import laVozDeAlmeriaImage from './images/lavozdealmeria.png';
import diarioDeMallorcaImage from './images/diariodemallorca.png';
import diarioDeSevillaImage from './images/diariodesevilla.png';
import diarioVascoImage from './images/diariovasco.png';
import elCorreoWebImage from './images/elcorreoandalucia.png';
import laInformacionImage from './images/lainformacion.png';
import laVozDelSurImage from './images/lavozdelsur.png';
import malagahoyImage from './images/malagahoy.png';
import mujerhoyImage from './images/mujerhoy.png';
import murciadiaroImage from './images/murciadiario.png';
import teleCincoImage from './images/teleCinco.png';
import teleMadridImage from './images/teleMadrid.png';

export const linksProps = {
  links: [
    {
      imageUrl: la1Image,
      imageAltText: 'La 1 ',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.facebook.com/watch/?v=585122288865064',
      },
      text: "El confinamiento ha hecho que muchos valoren una vivienda con jardín y piscina, y si piscina no tienes, hay soluciones.",
    },
    {
      imageUrl: antena3Image,
      imageAltText: 'Antena 3',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.facebook.com/watch/?v=4640319259342155',
      },
      text: "Ahora que tenemos una situación un poco complicada, es una buena forma para hacer que la gente disfrute con tu jardín y con tu piscina.",
    },
    {
      imageUrl: teleCincoImage,
      imageAltText: 'TeleCinco',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.facebook.com/watch/?v=306212870492430',
      },
      text: "¡No se muevan! Si están deseando darse un baño y ustedes no tienen una piscina, ahora se pueden alquilar.",
    },
    {
      imageUrl: teleMadridImage,
      imageAltText: 'TeleMadrid',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.facebook.com/watch/?v=231823931354799',
      },
      text: "Es una gran idea, porque primero, rentabilizas la piscina. Segundo, conoces a un montón de gente. Y tercero, compartes.",
    },
  ],
};

export const pressPageProps = {
  links: [
    {
      date: '22/07/2019',
      imageUrl: cadenaserImage,
      imageAltText: 'Cadenaser',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://cadenaser.com/ser/2019/07/22/sociedad/1563774420_490682.html',
      },
      text: 'Para alquilar una piscina, tan solo tienes que registrarte en la misma, completar tu perfil y decantarte por aquella que más te guste. En la página encontrarás una breve descripción de la piscina, su capacidad y algunos de los extras con los que cuenta. Desde jardín o tumbonas hasta ducha, barbacoa e incluso campo de petanca.',
    },
    {
      date: '22/07/2019',
      imageUrl: laVozDeAlmeriaImage,
      imageAltText: 'La Voz de Almeria',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.lavozdealmeria.com/noticia/4/sociedad/175691/swimmy-el-airbnb-de-las-piscinas',
      },
      text: "si estás buscando una piscina para celebrar una fiesta o, simplemente, pegarte un buen chapuzón, Swimmy te permitirá encontrar aquella que más se ajuste a tus necesidades en minutos. ¿Quieres ofrecer la tuya a terceros? ¡También puedes! Tan solo tienes que introducir algunos datos básicos sobre la misma, una fotografía y un precio de salida.",
    },
    {
      date: '18/07/2019',
      imageUrl: businessInsiderImage,
      imageAltText: 'Business Insider',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.businessinsider.es/swimmy-airbnb-piscinas-llega-espana-debes-saber-458453',
      },
      text: "Esta plataforma ofrece la posibilidad a que los dueños de piscinas en casas y apartamentos puedan ponerlas en alquiler para el disfrute de turistas o vecinos. Lo bueno es que no sólo permite obtener beneficios económicos gracias al arrendamiento, también fomenta las relaciones sociales.",
    },
    {
      date: '23/07/2019',
      imageUrl: antena3Image,
      imageAltText: 'Antena3',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.antena3.com/noticias/economia/llega-espana-swimmy-app-que-alquilar-piscinas-particulares_201907235d36dc250cf25505893c83af.html',
      },
      text: "España cuenta desde este mes de julio con una nueva iniciativa de economía colaborativa: la de la plataforma francesa Swimmy, que propone un servicio de alquiler de piscinas entre particulares.",
    },
    {
      date: '23/07/2019',
      imageUrl: murciadiaroImage,
      imageAltText: 'Murciadiaro',
      linkProps: {
        type: 'ExternalLink',
        href:
          'http://murciadiario.com/art/16384/llega-a-espana-swimmy-el-airbnb-de-las-piscinas',
      },
      text: "La firma, fundada por Raphaelle de Monteynard, llega ahora a España, el segundo mercado más importante de Europa, con más de un millón de piscinas privadas, para facilitar el contacto entre los dueños de estas instalaciones y potenciales usuarios, para sacarles el máximo rendimiento.",
    },
    {
      date: '24/07/2019',
      imageUrl: elCorreoWebImage,
      imageAltText: 'El Correo Web',
      linkProps: {
        type: 'ExternalLink',
        href: 'http://elcorreoweb.es/sevilla/llega-a-sevilla-swimmy-el-amigo-que-tiene-piscina-CJ5685765',
      },
      text: 'El verano en Sevilla es un suplicio y muchos son los que no tienen a mano la posibilidad de ir a una a darse un baño. Viendo esta carencia, una empresa francesa desembarca en Sevilla con Swimmy. Esta plataforma «propone un servicio de alquiler de piscinas entre particulares para permitir que los propietarios de piscinas compartan su bien con turistas o vecinos.',
     },
     {
      date: '24/07/2019',
      imageUrl: elPeriodicoImage,
      imageAltText: 'El Periodico',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://viajar.elperiodico.com/viajeros/llega-espana-airbnb-piscinas',
      },
      text: 'Swimmy. Así se llama la plataforma francesa que ha aterrizado en nuestro país y que consiste en ceder tu piscina durante una hora, una tarde o un día entero. Es el mismo concepto que usa la conocida aplicación, Aribnb, para alquilar casas o habitaciones de forma temporal, pero en este caso con piscinas.',
     },
     {
      date: '26/07/2019',
      imageUrl: conDeNastTravelerImage,
      imageAltText: 'Con De Nast Traveler',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.traveler.es/experiencias/articulos/swimmy-alquilar-piscinas-privadas-espana/15802',
      },
      text: 'El sistema es sencillo: el propietario de una piscina introduce en la plataforma la información relativa a la misma. A saber: descripción de la piscina y apuntes sobre posibles extras, como si está climatizada, si tiene jardín, si hay tumbonas, ducha, spa, jacuzzi, mesas y sillas, barbacoa, pista de tenis, campo de petanca o de fútbol.',
     },
     {
      date: '28/07/2019',
      imageUrl: laInformacionImage,
      imageAltText: 'La Informacion',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.lainformacion.com/asuntos-sociales/airbnb-piscinas-espana-swimmy/6507393/',
      },
      text: '"La felicidad se comparte". Es el lema que se puede  leer en su página web. Hablamos de Swimmy o, dicho de una forma más sencillo, el nuevo Airbnb de las piscinas que, recientemente, ha aterrizado en España. ¿Para qué sirve esta plataforma? Básicamente para que todas aquellas personas que dispongan de un chalet con piscina o un terreno más o menos extenso como un jardín, pueden alquilarlo por un tiempo determinado a cualquiera.',
     },
     {
      date: '01/08/2019',
      imageUrl: mujerhoyImage,
      imageAltText: 'Mujerhoy',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.mujerhoy.com/vivir/ocio/201908/01/swimmy-airbnb-piscinas-aplicacion-espa%C3%B1a-20190801102759.html ',
      },
      text: 'Swimmy es básicamente el Airbnb de las piscinas y ya está disponible en España. En julio de 2017, la francesa Raphaëlle de Monteynard fundó Swimmy, que es básicamente una plataforma de alquiler de piscinas y jardines. Esta plataforma te ayuda a encontrar un espacio que se amolde a tus necesidades para organizar una gran fiesta, celebrar un cumpleaños o simplemente pegarse un buen chapuzón. Y ahora este servicio llega a España.',
     },
     {
      date: '06/08/2019',
      imageUrl: diarioDeSevillaImage,
      imageAltText: 'Diario De Sevilla',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.diariodesevilla.es/vivirensevilla/Swimmy-web-alquiler-piscinas-particulares_0_1379862164.html',
      },
      text: 'Tanto propietarios como bañistas deseosos de ponerse a remojo encuentran en este portal la solución a disfrutar de un día de piscina. Para los primeros, supone un beneficio económico y dotar de utilidad a la zona de baño que, bien por vacaciones o bien por simple falta de uso, no está siendo aprovechada. Para los segundos, poder refrescarse en un ambiente privado, rodeado sólo de amigos o familiares, donde poder relajarse o celebrar un pequeño evento o celebración y sin ni siquiera salir de Sevilla.',
     },
     {
      date: '08/08/2019',
      imageUrl: diarioVascoImage,
      imageAltText: 'Diario Vasco',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.diariovasco.com/sociedad/swimmy-airbnb-piscinas-20190808063518-nt.html',
      },
      text: 'En julio de 2017, la francesa Raphaëlle de Monteynard fundó Swimmy, que es básicamente una plataforma de alquiler de piscinas y jardines. Esta plataforma te ayuda a encontrar un espacio que se amolde a tus necesidades para organizar una gran fiesta, celebrar un cumpleaños o simplemente pegarse un buen chapuzón. Y ahora este servicio llega a España.',
     },
     {
      date: '10/08/2019',
      imageUrl: laVozDelSurImage,
      imageAltText: 'La Voz Del Sur',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.lavozdelsur.es/el-airbnb-de-las-piscinas-privadas-llega-a-andalucia/',
      },
      text: 'Quien tiene una piscina en casa, tiene un tesoro. Eso debieron pensar las personas que a principios de julio se atrevieron a compartir sus piscinas privadas con desconocidos. Bueno, más que compartir, alquilar, porque en eso consiste la plataforma web Swimmy.es, creada en Francia hace dos años y que este verano ha recalado en tierras españolas para alivio de quien no sabe cómo refrescarse cuando aprieta el calor y no tiene cerca ni la playa ni a un amigo con piscina.',
     },
     {
      date: '23/08/2019',
      imageUrl: abcImage,
      imageAltText: 'ABC',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.abc.es/espana/madrid/abci-swimmy-aplicacion-para-alquilar-piscinas-privadas-llega-madrid-201908231204_noticia.html',
      },
      text: 'Está de moda compartir. Como si de un Airbnb se tratara, en «Swimmy» es posible colgar una foto de la piscina, las condiciones, el lugar donde se encuentra y el precio y esperar a que alguien se interese por ello. También se puede indicar el número máximo de personas que se admiten por día y si el propietario e va a encontrar o no en el alojamiento durante el tiempo en el que se haya alquilado la piscina.',
     },
     {
      date: '23/08/2019',
      imageUrl: elPaisImage,
      imageAltText: 'El Pais',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://elpais.com/ccaa/2019/08/14/madrid/1565789782_502353.html',
      },
      text: 'Una nueva aplicación permite a los usuarios ponerse en remojo por alrededor de 15 euros medio día en una piscina privada. Swimmy llegó en julio a España y la plataforma cuenta con más de 100 propietarios de casas con piscinas en 15 ciudades que han decidido arrendar durante unas horas una parte de sus viviendas a desconocidos.',
     },
     {
      date: '24/08/2019',
      imageUrl: diarioDeMallorcaImage,
      imageAltText: 'Diario De Mallorca',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.diariodemallorca.es/sociedad/2019/08/24/alquila-piscina-horas/1443056.html',
      },
      text: '"El propietario puede decidir cuánto tiempo puede ceder sus instalaciones", explican desde Swimmy. "Las reservas y el pago se gestionan a través de la web. Una vez el propietario acepta la solicitud de reserva, se muestran tanto los datos personales del dueño como el número de teléfono o el lugar donde se encuentra la piscina".',
     },
     {
      date: '27/08/2019',
      imageUrl: laRazonImage,
      imageAltText: 'La Razon',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.larazon.es/local/andalucia/chapuzones-al-alcance-de-un-clic-IJ24699537',
      },
      text: 'Acostumbrados a utilizar en el día a día plataformas como Cabify, Uber, Airbnb o Blablacar ahora le toca el turno a las piscinas con Swimmy. Esta página web tiene como fin poner en contacto a propietarios de más de cien piscinas –ya sean cavadas, hinchables, jacuzzis o incluso spas– con interesados en disfrutar de un buen chapuzón.',
     },
     {
      date: '31/08/2019',
      imageUrl: malagahoyImage,
      imageAltText: 'Malagahoy',
      linkProps: {
        type: 'ExternalLink',
        href: 'https://www.malagahoy.es/malaga/Airbnb-piscinas_0_1387061604.html',
      },
      text: 'Swimmy nació de una tarde calurosa y de amigos, lo que viene siendo un típico día de verano. Entre chapuzón y chapuzón, a su creadora, Raphaelle de Monteynard, se le ocurrió que sería genial que todos pudieran disfrutar de un día de piscina aunque no dispusieran de una, así que pensó, si no puedes tirarte a la tuya, ¿por qué no a la de al lado?',
     },
  ],
};

export const rentMyPageProps = {
  links: [
    {
      imageUrl: elPaisImage,
      imageAltText: 'El Pais',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://elpais.com/ccaa/2019/08/14/madrid/1565789782_502353.html',
      },
    },
    {
      imageUrl: abcImage,
      imageAltText: 'ABC',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.abc.es/espana/madrid/abci-swimmy-aplicacion-para-alquilar-piscinas-privadas-llega-madrid-201908231204_noticia.html',
      },
    },
    {
      imageUrl: laRazonImage,
      imageAltText: 'France 3',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.larazon.es/economia/llega-a-espana-swimmy-el-airbnb-de-las-piscinas-FE24317255',
      },
    },
    {
      imageUrl: elPeriodicoImage,
      imageAltText: 'El Periodico',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://viajar.elperiodico.com/viajeros/llega-espana-airbnb-piscinas',
      },
    },
    {
      imageUrl: elPaisImage,
      imageAltText: 'EL Pais',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://cincodias.elpais.com/cincodias/2019/07/22/mercados/1563816203_191027.html',
      },
    },
    {
      imageUrl: elEconomistaImage,
      imageAltText: 'El Economista',
      linkProps: {
        type: 'ExternalLink',
        href:
          'https://www.eleconomista.es/empresas-finanzas/noticias/10017537/07/19/La-economia-colaborativa-avanza-asi-es-Swimmy-el-AirBnB-de-las-piscinas-que-aterriza-en-Espana.html',
      },
    },
  ],
};
